import { api } from "@/api"

import { queryClient } from "@/queryClient"

export const updateProductModifier = async (
  productModifierGroupId: string,
  params: CreateUpdateProductModifierBody
) => {
  const { body } = await api.put<{ id: string }>(
    `/products/product-modifiers/${productModifierGroupId}/`,
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCT_MODIFIERS_QUERY_KEY],
  })
  return body
}
